<template>
  <div id="editar-lojista" class="ver-dica">
    <div class="form-fields position-relative" v-if="!checkIsEmpty(lojista)">
      <h1 class="title text-uppercase font-weight-bold">Editar Lojista</h1>
      <hr class="linha-amarela" />

      <div class="row">
        <div class="col-12">
          <div class="planos p-0">
            <div
              class="card-plano position-relative"
              v-if="
                !checkIsEmpty(lojista[0].plano) &&
                lojista[0].plano.plano_id === 3
              "
            >
              <div>
                <span
                  class="recomend-span fs-12 font-weight-bold text-uppercase position-absolute"
                >
                  Selecionado
                </span>
              </div>
              <div
                class="card-header position-relative text-uppercase font-weight-bold text-center fs-22"
              >
                <label class="checktainer c-pointer m-0">
                  <input
                    type="radio"
                    name="plano"
                    v-model="dados.plano.value"
                    class="plano-checkbox"
                    value="3"
                  />Plano 3
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="card-body">
                <div class="fs-20 text-center text-uppercase">
                  4,0% da venda
                </div>
                <div class="fs-14 text-center p-4px">pela Plataforma</div>
              </div>
              <div class="card-footer p-5px">
                <div
                  class="w-100 c-pointer btn btn-aceitar-contrato"
                  @click="showContratoPlano('contrato-lojista-plano-pagamento')"
                >
                  Ver o contrato
                </div>
              </div>
            </div>
            <div class="card-plano">
              <div
                class="d-flex justify-content-center"
                v-if="
                  !checkIsEmpty(lojista[0].plano) &&
                  lojista[0].plano.plano_id === 1
                "
              >
                <span
                  class="plano-adm-span fs-12 font-weight-bold text-uppercase position-absolute"
                  >Selecionado</span
                >
              </div>
              <div
                class="card-header position-relative text-uppercase font-weight-bold text-center fs-22"
              >
                <label class="checktainer c-pointer m-0">
                  <input
                    type="radio"
                    name="plano"
                    v-model="dados.plano.value"
                    class="plano-checkbox"
                    value="1"
                  />Plano 1
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="card-body">
                <div class="fs-28 text-center">R$ 49,90</div>
                <div class="fs-12 text-center">Mensal + 1% da venda</div>
              </div>
              <div class="card-footer p-5px">
                <div class="w-100 c-pointer btn btn-aceitar-contrato">
                  Ver e aceitar o contrato
                </div>
              </div>
            </div>
            <div class="card-plano">
              <div
                class="d-flex justify-content-center"
                v-if="
                  !checkIsEmpty(lojista[0].plano) &&
                  lojista[0].plano.plano_id === 2
                "
              >
                <span
                  class="plano-adm-span fs-12 font-weight-bold text-uppercase position-absolute"
                  >Selecionado</span
                >
              </div>
              <div
                class="card-header position-relative text-uppercase font-weight-bold text-center fs-22"
              >
                <label class="checktainer c-pointer m-0">
                  <input
                    type="radio"
                    name="plano"
                    v-model="dados.plano.value"
                    class="plano-checkbox"
                    value="2"
                  />Plano 2
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="card-body">
                <div class="fs-20 text-center text-uppercase">2% da venda</div>
                <div class="fs-12 text-center p-4px">pela Plataforma</div>
              </div>
              <div class="card-footer p-5px">
                <div class="w-100 c-pointer btn btn-aceitar-contrato">
                  Ver e aceitar o contrato
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="cadastroRazaoSocial">Razão Social</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.razao_social.value"
              id="cadastroRazaoSocial"
              aria-describedby="Razão Social para Cadastro"
              :placeholder="lojista[0].razao_social"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroNomeFantasia">Nome Fantasia</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.nome_fantasia.value"
              id="cadastroNomeFantasia"
              aria-describedby="Nome Fantasia para Cadastro"
              :placeholder="lojista[0].nome_fantasia"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroNomeResponsavel">Nome Responsável</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.nome_responsavel.value"
              id="cadastroNomeResponsável"
              aria-describedby="Nome Responsável para Cadastro"
              :placeholder="lojista[0].nome_responsavel"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroRG">RG</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.rg.value"
              id="cadastroRG"
              v-mask="'##.###.###-#'"
              aria-describedby="RG para Cadastro"
              :placeholder="lojista[0].rg"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCpf">CPF</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cpf.value"
              id="cadastroCpf"
              v-mask="'###.###.###-##'"
              aria-describedby="Cpf para Cadastro"
              :placeholder="lojista[0].cpf"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCnpj">CNPJ</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cnpj.value"
              id="cadastroCnpj"
              v-mask="'##.###.###/####-##'"
              aria-describedby="CNPJ para Cadastro"
              :placeholder="lojista[0].cnpj"
            />
          </div>
        </div>
        <div class="col-lg-8">
          <div class="form-group">
            <label for="cadastroEndereco">Endereço</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.endereco.value"
              id="cadastroEndereco"
              aria-describedby="Endereço para Cadastro"
              :placeholder="lojista[0].endereco"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroNumero">Número</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.numero.value"
              id="cadastroNumero"
              aria-describedby="Número para Cadastro"
              :placeholder="lojista[0].numero"
            />
          </div>
        </div>
        <div class="col-lg-8">
          <div class="form-group">
            <label for="cadastroComplemento">Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.complemento.value"
              id="cadastroComplemento"
              aria-describedby="Complemento para Cadastro"
              :placeholder="lojista[0].complemento"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCep">CEP</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cep.value"
              id="cadastroCep"
              v-mask="'#####-###'"
              aria-describedby="CEP para Cadastro"
              :placeholder="lojista[0].cep"
            />
          </div>
        </div>
        <div class="col-lg-5">
          <div class="form-group">
            <label for="cadastroBairro">Bairro</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.bairro.value"
              id="cadastroBairro"
              aria-describedby="Bairro para Cadastro"
              :placeholder="lojista[0].bairro"
            />
          </div>
        </div>
        <div class="col-lg-5">
          <div class="form-group">
            <label for="cadastroCidade">Cidade</label>
            <v-select
              id="cadastroCidade"
              label="nome"
              v-model="dados.cidade.value"
              :options="cidades"
              :placeholder="
                lojista[0].cidade !== null ? lojista[0].cidade.nome : ''
              "
            ></v-select>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <!-- <label for="cadastroEstado">UF</label>
                  <v-select id="cadastroEstado" label="uf" v-model="dados.estado.value" :options="estados" :placeholder="(lojista[0].estado !== null)? lojista[0].estado.uf : ''"
                  >
                  </v-select> -->
            <label for="cadastroEstado">UF</label>
            <v-select
              id="cadastroEstado"
              label="uf"
              :options="estados"
              v-model="dados.estado.value"
              :placeholder="
                lojista[0].estado !== null ? lojista[0].estado.uf : ''
              "
            ></v-select>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCelular">Celular / Whatsapp</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.celular.value"
              id="cadastroCelular"
              v-mask="['(##) #####-####', '(##) ####-####']"
              aria-describedby="Celular para Cadastro"
              :placeholder="lojista[0].celular"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroTelefone">Telefone</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.telefone.value"
              id="cadastroTelefone"
              v-mask="'(##) ####-####'"
              aria-describedby="Telefone para Cadastro"
              :placeholder="lojista[0].telefone"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroTelefone2">Telefone 2</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.telefone2.value"
              id="cadastroTelefone2"
              v-mask="'(##) ####-####'"
              aria-describedby="Telefone 2 para Cadastro"
              :placeholder="lojista[0].telefone2"
            />
          </div>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-lg-12">
          <h4>Contato do financeiro</h4>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroFNomeResponsavel">Nome do Responsável</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cFNome.value"
              id="cadastroFNomeResponsavel"
              aria-describedby="Telefone 2 para Cadastro"
              :placeholder="lojista[0].telefone2"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroFEmailResponsavel">E-mail do Responsável</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cFEmail.value"
              id="cadastroFEmailResponsavel"
              aria-describedby="Telefone 2 para Cadastro"
              :placeholder="lojista[0].telefone2"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroFCelular">Telefone / Celular</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cFCelular.value"
              id="cadastroFCelular"
              v-mask="['(##) ####-####', '(##) #####-####']"
              aria-describedby="Telefone 2 para Cadastro"
              :placeholder="lojista[0].telefone2"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroFRamal">Ramal</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cFRamal.value"
              id="cadastroFRamal"
              aria-describedby="Telefone 2 para Cadastro"
              :placeholder="lojista[0].telefone2"
            />
          </div>
        </div>
        <div class="col-lg-12">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroEmail">E-mail</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.email.value"
              id="cadastroEmail"
              aria-describedby="E-mail para cadastro"
              :placeholder="lojista[0].email"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroSenha">Senha</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.senha.value"
              id="cadastroSenha"
              aria-describedby="Senha para cadastro"
              placeholder="******"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h6>
            Segmentos
            <div
              class="btn bg-orange c-white c-white-hover border-50"
              @click="adicionarSegmento()"
            >
              <i class="fas fa-plus"></i>
            </div>
          </h6>
        </div>
      </div>
      <div class="row" v-if="lojista[0].segmentos.length > 0">
        <div class="col-4" v-for="(segmento, index) in lojista[0].segmentos">
          <div class="form-group">
            <v-select
              label="nome"
              v-model="segmento.segmento"
              :options="segmentos"
              placeholder="Digite o nome de um segmento"
              ><div slot="no-options">Não existente.</div></v-select
            >
            <div class="btn-remove" @click="excluirSegmentos(index)">
              <i class="fas fa-times"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="btn btn-success" @click="salvarLojista()">Editar</div>
        <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Esse lojista não existe mais!</h1>
    </div>

    <PaymentPlanContract
      v-if="!checkIsEmpty(lojista[0].plano) && lojista[0].plano.plano_id === 3"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PaymentPlanContract from '../../components/PaymentPlanContract.vue';

export default {
  name: 'editar-lojista',
  components: {
    PaymentPlanContract,
  },
  data: () => ({
    dados: {
      email: {
        value: null,
      },
      senha: {
        value: null,
      },
      nome_usuario: {
        value: null,
      },
      razao_social: {
        value: null,
      },
      nome_fantasia: {
        value: null,
      },
      nome_responsavel: {
        value: null,
      },
      rg: {
        value: null,
      },
      cpf: {
        value: null,
      },
      cnpj: {
        value: null,
      },
      celular: {
        value: null,
      },
      telefone: {
        value: null,
      },
      telefone2: {
        value: null,
      },
      endereco: {
        value: null,
      },
      complemento: {
        value: null,
      },
      numero: {
        value: null,
      },
      bairro: {
        value: null,
      },
      cidade: {
        value: null,
      },
      estado: {
        value: null,
      },
      cep: {
        value: null,
      },
      plano: {
        value: null,
      },
      cFNome: {
        value: null,
      },
      cFEmail: {
        value: null,
      },
      cFCelular: {
        value: null,
      },
      cFRamal: {
        value: null,
      },
    },
  }),
  props: ['id'],
  computed: {
    ...mapState({
      lojista: (state) => state.lojista,
      estados: (state) => state.estados,
      cidades: (state) => state.cidades,
      segmentos: (state) => state.segmentos,
    }),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.$store
      .dispatch('showLojista', this.id)
      .then(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1500);
      })
      .catch(() => {
        setTimeout(() => {
          this.$store.dispatch('showLojista', this.id).then(() => {
            this.$store.dispatch('endLoader');
          });
        }, 1500);
      });
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadEstados');
    this.$store.dispatch('loadSegmentos');
    if (!this.checkIsEmpty(this.lojista)) {
      if (this.lojista[0] !== null && this.lojista[0].plano !== null) {
        this.dados.plano.value = this.lojista[0].plano.plano_id;
      }
    }
  },
  mounted() {
    this.$store.dispatch('showLojista', this.id).then(() => {
      setTimeout(() => {
        if (!this.checkIsEmpty(this.lojista)) {
          this.dados.email.value = this.lojista[0].email;
          this.dados.razao_social.value = this.lojista[0].razao_social;
          this.dados.nome_fantasia.value = this.lojista[0].nome_fantasia;
          this.dados.nome_responsavel.value = this.lojista[0].nome_responsavel;
          this.dados.rg.value = this.lojista[0].rg;
          this.dados.cpf.value = this.lojista[0].cpf;
          this.dados.cnpj.value = this.lojista[0].cnpj;
          this.dados.celular.value = this.lojista[0].celular;
          this.dados.telefone.value = this.lojista[0].telefone;
          this.dados.telefone2.value = this.lojista[0].telefone2;
          this.dados.endereco.value = this.lojista[0].endereco;
          this.dados.complemento.value = this.lojista[0].complemento;
          this.dados.numero.value = this.lojista[0].numero;
          this.dados.bairro.value = this.lojista[0].bairro;
          this.dados.cidade.value = this.lojista[0].cidade;
          this.dados.estado.value = this.lojista[0].estado;
          this.dados.cep.value = this.lojista[0].cep;

          if (
            this.lojista[0].financeiro !== null &&
            this.lojista[0].financeiro !== 'null'
          ) {
            this.dados.cFNome.value = this.lojista[0].financeiro.nome;
            this.dados.cFEmail.value = this.lojista[0].financeiro.email;
            this.dados.cFCelular.value = this.lojista[0].financeiro.celular;
            this.dados.cFRamal.value = this.lojista[0].financeiro.ramal;
          }
        }
      }, 1500);
    });
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    salvarLojista() {
      const self = this;
      const data = {
        id: this.lojista[0].usuario_id,
        id_lojista: this.lojista[0].id,
        email: this.dados.email.value,
        nome_usuario: this.dados.nome_usuario.value,
        razao_social: this.dados.razao_social.value,
        nome_fantasia: this.dados.nome_fantasia.value,
        nome_responsavel: this.dados.nome_responsavel.value,
        rg: this.dados.rg.value,
        cpf: this.dados.cpf.value,
        cnpj: this.dados.cnpj.value,
        celular: this.dados.celular.value,
        telefone: this.dados.telefone.value,
        telefone2: this.dados.telefone2.value,
        endereco: this.dados.endereco.value,
        complemento: this.dados.complemento.value,
        numero: this.dados.numero.value,
        bairro: this.dados.bairro.value,
        cidade: this.dados.cidade.value,
        estado: this.dados.estado.value,
        cep: this.dados.cep.value,
        password: this.dados.senha.value,
        segmentos: this.lojista[0].segmentos,
        plano: this.dados.plano.value,
        cFNome: this.dados.cFNome.value,
        cFEmail: this.dados.cFEmail.value,
        cFCelular: this.dados.cFCelular.value,
        cFRamal: this.dados.cFRamal.value,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateLojistaByAdm', data)
        .then((data) => {
          setTimeout(() => {
            this.$store.dispatch('showLojista', this.id);
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.aviso('Editado com Sucesso!', 'success');
            });
          }, 1000);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.aviso('Houve um problema em realizar essa edição!', 'success');
        });
    },
    adicionarSegmento() {
      this.lojista[0].segmentos.push({
        segmento: {
          nome: 'Digite o nome de um segmento',
        },
      });
    },
    excluirSegmentos(index) {
      this.lojista[0].segmentos.splice(index, 1);
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-lojistas',
      });
    },
    showContratoPlano(idPlano) {
      this.$bvModal.show(idPlano);
    },
    hideContratoPlano(idPlano) {
      this.$bvModal.hide(idPlano);
    },
  },
};
</script>
